import { render, staticRenderFns } from "./PpeRegisterForm.vue?vue&type=template&id=3e057512&"
import script from "./PpeRegisterForm.vue?vue&type=script&lang=js&"
export * from "./PpeRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports